module.exports = __webpack_public_path__ + "img/check-circle.4bfb0c9a.svg";